import { render, staticRenderFns } from "./MemberNotification.vue?vue&type=template&id=be2daf9a&"
import script from "./MemberNotification.vue?vue&type=script&lang=js&"
export * from "./MemberNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports